<div *ngIf="!statsMode" class="step-wrapper" [class.start-step]="step.isStart" [class.has-entity]="step.entityId">
	<div class="title">
		{{ 'START' | translate }}
	</div>
	<div class="outer-container"
		[style.background-image]="step.entityId ? (step.entityId | thumbnail:step.width:step.height:'backgroundUrl' | async ) : ''">
		<div class="file-hover">
			<i class="fa fa-upload"></i>
		</div>
		<div class="gradient-overlay-wrapper">
			<div class="gradient-overlay"></div>
		</div>
		<div class="inner-container">
			<div class="description">
				<div class="inner">
					<div *ngIf="step.entityId && step.entityType && step.entityType.toLowerCase() === 'mediaclip'"
						class="thumbnail-overlay">
					</div>
					<div class="text">
						<span class="inner-text" [ngClass]="{'set-to-start': step.description?.length >= 50}">
							{{ step.description }}
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="in"> </div>
</div>

<!-- statsMode -->
<div class="stats-step-wrapper" *ngIf="statsMode">
	<flowchart-stats-step [project]="project" [step]="step" [selected]="selected">
	</flowchart-stats-step>
</div>
